import { Box, Grid, useTheme, Typography, IconButton } from '@mui/material';
import { tokens } from "../theme";
import DeleteIcon from '@mui/icons-material/Delete';

import { editProduct, getImageUrl } from "../utils/apiHelpers";

import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

const AdminProduct = ({product, productIndex, onDelete, updateProductFunction}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    console.log(product.image_path)

    return (
        <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ backgroundColor: productIndex % 2 === 0 ? colors.gray[800] : colors.gray[700], width: '100%' }}
        >
            <Box sx={{m: "5px 10px 5px 10px"}}>
            {
            product.image_path !== ""
            ? <img src={getImageUrl(product.image_path)} width="60px" height="60px" alt="Produktbild" />
            : null
            }
            </Box>
            <Grid container spacing={0} sx={{m: "0 10px 0 0", flex: 1}}>
            <Grid size={4}>
                <Box display="flex" flexDirection="column">
                <Typography variant="h3" color={colors.gray[100]}>
                    {product.name}
                </Typography>
                <Typography variant="h4" color={colors.gray[100]}>
                    Pris: {product.price} kr
                </Typography>
                </Box>
            </Grid>
            <Grid size={7} display="flex" justifyContent="flex-end" alignItems="center">
                <IconButton sx={{m: "0 10px 0 0"}} onClick={() => {
                    const newProductData = {
                        ...product,
                        // Remove admin if admin, otherwise promote
                        active: product.active == 1 ? 0 : 1
                    };
                    editProduct(newProductData).then(updateProductFunction)
                }}>
                    {
                        product.active ? <ToggleOnIcon /> : <ToggleOffIcon />
                    }
                </IconButton>
            </Grid>
            <Grid size={1} display="flex" justifyContent="center" alignItems="center">
                <IconButton onClick={onDelete}>
                <DeleteIcon/>
                </IconButton>
            </Grid>
            </Grid>
        </Box>
    )
}

export default AdminProduct